var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorUndoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 18,
    viewBox: "0 0 40 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V17.6031H17.6031L10.5208 10.5208C12.4689 8.87657 14.7906 7.73544 17.2824 7.1974C19.7741 6.65937 22.3599 6.74087 24.8128 7.43476C27.2657 8.12865 29.511 9.41374 31.3517 11.1773C33.1924 12.9409 34.5723 15.1292 35.3704 17.5502L40 16.007C38.94 12.7937 37.1001 9.89314 34.6449 7.56479C32.1897 5.23645 29.1957 3.5529 25.9306 2.66471C22.6656 1.77653 19.2314 1.71139 15.935 2.47512C12.6387 3.23886 9.58296 4.80766 7.04122 7.04122L0 0Z",
    fill: "#B30200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorUndoIcon);
export default __webpack_public_path__ + "static/media/errorUndoIcon.c31048345bc6afc6e0d12c5447cab22d.svg";
export { ForwardRef as ReactComponent };